import { applySorting } from "utils";
import { fetchEmployees } from "directus/src/operations";
import { queryClient } from "utils/react-query";

export const createListQuery = (params, queryOptions = {}) => {
  const {
    endpoint,
    page = 1,
    perPage = 25,
    search = "",
    sortBy,
    sortOrder = "desc",
    filters = {},
    meta = {},
    enabled = true,
    attrs,
  } = params;

  const queryKey = [
    "employees",
    "list",
    {
      page,
      perPage,
      search,
      sortBy,
      sortOrder,
      filters,
      fields: attrs || meta?.attrs,
      filter: meta.filter,
    },
  ];

  const queryFn = async () => {
    const query = {
      deep: meta.deep,
      limit: perPage,
      page,
      search: search,
      sort: applySorting(sortBy, sortOrder),
      fields: attrs || meta?.attrs,
      filter: filters,
    };

    try {
      const [response, countResponse] = await Promise.all([
        fetchEmployees(query),
        fetchEmployees({
          aggregate: {
            countDistinct: ["id"],
          },
          search: search,
          filter: query?.filter || {},
        }),
      ]);

      return {
        items: response,
        count: countResponse?.[0]?.countDistinct.id || 0,
        meta: {},
      };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  return {
    queryKey,
    queryFn,
    enabled: enabled,
    placeholderData: (previousData) => previousData, // Replaces keepPreviousData
    ...queryOptions,
  };
};

export const fetchListData = async (params, queryOptions = {}) => {
  const queryConfig = createListQuery(params, queryOptions);
  return await queryClient.fetchQuery(queryConfig);
};
